var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',{staticClass:"grey lighten-4 main"},[_c('v-container',{attrs:{"fluid":""}},[_c('top-nav-bar',{attrs:{"hasDrawer":false,"homePath":_vm.homePath}},[[_vm._t("topNavBar")]],2),_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }